module.exports = __webpack_public_path__ + "img/003_thelevitation.518592e4.gif";